import { FormControl, Validators } from '@angular/forms';

const COUNTRY_CODE_PATTERN = /^[a-z]+$/i;

function vatNumberRequired(control: FormControl<string>): { required: boolean } | null {
  return COUNTRY_CODE_PATTERN.test(control.value) ? { required: true } : null;
}

export const vatNumberRequiredValidator = Validators.compose([
  Validators.required,
  vatNumberRequired,
]);
